import { v1 as uuidv1 } from "uuid";

export const getUniqueUserId = () => {
	// Using uuid v1 as it gives us Uniqueness
	return uuidv1();
};
